'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Home;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _containers = require('../containers');

var _ = require('.');

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Home() {
  var dateFormat = function dateFormat(_ref) {
    var next_date = _ref.next_date;
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'day' },
        (0, _moment2.default)(next_date).format('Do'),
        ' '
      ),
      _react2.default.createElement(
        'span',
        { className: 'month' },
        (0, _moment2.default)(next_date).format('MMM')
      )
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'Home' },
    _react2.default.createElement(
      'section',
      { className: 'intro' },
      _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(
          'h1',
          null,
          'Le calendrier collectif pour d\xE9couvrir quoi faire ',
          _react2.default.createElement(_containers.RegionPickerContainer, null)
        ),
        _react2.default.createElement('img', { src: '/party.svg', alt: '' })
      )
    ),
    _react2.default.createElement(
      'section',
      { className: 'search' },
      _react2.default.createElement(_containers.SearchBarContainer, null)
    ),
    _react2.default.createElement(
      _containers.ShowcaseContainer,
      { title: 'En vedette', query: _config2.default.app.showcases.featured },
      function (props) {
        return _react2.default.createElement(
          'section',
          { className: 'carousel', id: 'featured' },
          _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', columns: 2, container: 6, groupBy: 'none', dateFormat: dateFormat }, props))
        );
      }
    ),
    _react2.default.createElement(
      _containers.ShowcaseContainer,
      { title: 'Arts et spectacles', query: _config2.default.app.showcases.arts },
      function (props) {
        return _react2.default.createElement(
          'section',
          { className: 'carousel yellow' },
          _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', groupBy: 'none', dateFormat: dateFormat }, props))
        );
      }
    ),
    _react2.default.createElement(
      _containers.ShowcaseContainer,
      { title: 'Enfants et tout-petits', query: _config2.default.app.showcases.enfants },
      function (props) {
        return _react2.default.createElement(
          'section',
          { className: 'carousel pink' },
          _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', groupBy: 'none', dateFormat: dateFormat }, props))
        );
      }
    ),
    _react2.default.createElement(
      _containers.ShowcaseContainer,
      { title: 'Conf\xE9rences et ateliers', query: _config2.default.app.showcases.conferences },
      function (props) {
        return _react2.default.createElement(
          'section',
          { className: 'carousel purple' },
          _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', groupBy: 'none', dateFormat: dateFormat }, props))
        );
      }
    ),
    _react2.default.createElement(
      _containers.ShowcaseContainer,
      { title: 'Un peu de tout', query: _config2.default.app.showcases.all },
      function (props) {
        return _react2.default.createElement(
          'section',
          { className: 'carousel dark-ochre' },
          _react2.default.createElement(_caligramReact.EventList, (0, _extends3.default)({ layout: 'carousel', groupBy: 'none', dateFormat: dateFormat }, props)),
          _react2.default.createElement(
            'div',
            { className: 'all' },
            _react2.default.createElement(_.RoundedButton, { title: 'Voir tous les \xE9v\xE9nements', iconRight: 'chevronRight', href: '/evenements' })
          )
        );
      }
    ),
    _react2.default.createElement(
      'section',
      { className: 'filters' },
      _react2.default.createElement(_containers.FiltersContainer, null)
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home.js
// module id = 1081
// module chunks = 0